import { useMemo } from "react";
import { StoreTeam } from "@coworker/types/lib/storeteam";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { TeamStatus } from "@coworker/apprestructured/src/shared/types/team";

import { PRODUCT_QUALITY_ID } from "./filters/useProductQualityFilter";
import { SORT_BY_ID, SORT_BY_VALUES } from "./filters/useTeamsSortByFilter";

const useFilteredTeams = (
  teams: StoreTeam[],
  filters: FilterValue[],
  searchQuery?: string
) =>
  useMemo(() => {
    if (teams?.length === 0) return [];

    let filteredTeams = teams?.filter((team) => {
      const conditionals: boolean[] = [];
      if (team.status === TeamStatus.INACTIVE) {
        conditionals.push(false);
      }
      filters?.forEach((filterValue) => {
        switch (filterValue.filterId) {
          case PRODUCT_QUALITY_ID:
            conditionals.push(team.is_product_quality === filterValue.value);
            break;
          default:
            break;
        }
      });
      if (searchQuery) {
        conditionals.push(
          team.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }
      return conditionals.every(Boolean);
    });

    if (filters?.find((filter) => filter.filterId === SORT_BY_ID)) {
      const sortByFilter = filters.find(
        (filter) => filter.filterId === SORT_BY_ID
      );
      if (sortByFilter) {
        switch (sortByFilter.value) {
          case SORT_BY_VALUES.TEAM_NAME_ALPHABETICAL_AZ:
            filteredTeams = filteredTeams.sort((a, b) =>
              a.name.localeCompare(b.name)
            );
            break;
          case SORT_BY_VALUES.TEAM_NAME_ALPHABETICAL_ZA:
            filteredTeams = filteredTeams.sort((a, b) =>
              b.name.localeCompare(a.name)
            );
            break;
          case SORT_BY_VALUES.TEAM_SIZE_DESC:
            filteredTeams = filteredTeams.sort(
              (a, b) => b.user_count - a.user_count
            );
            break;
          case SORT_BY_VALUES.TEAM_SIZE_ASC:
            filteredTeams = filteredTeams.sort(
              (a, b) => a.user_count - b.user_count
            );
            break;
          case SORT_BY_VALUES.CREATED_AT_ASC:
            filteredTeams = filteredTeams.sort(
              (a, b) => a.created_at - b.created_at
            );
            break;
          case SORT_BY_VALUES.CREATED_AT_DESC:
            filteredTeams = filteredTeams.sort(
              (a, b) => b.created_at - a.created_at
            );
            break;
          default:
            break;
        }
      }
    }

    return filteredTeams;
  }, [filters, teams, searchQuery]);

export default useFilteredTeams;
